<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">統一企画点検リスト</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txi_OrderCode" #txi_OrderCode
              [subid]="'txi_OrderCode'" [catalogIDField]="lbl_DelivCatalog" [tabindex]="0" [required]="true"
              [autofocus]="true" [(ngModel)]="kymw4100Model.orderCode" [forcedEnabledMode]="'true'">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回（翌週）</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_DelivCatalog" #lbl_DelivCatalog readonly>
          </div>

          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-plan-medium-type-combo-box id="cmb_Medium" #cmb_Medium [subid]="'cmb_Medium'" [required]="true"
              [forcedEnabledMode]="'true'" [tabindex]="0" [initFocusItem]="txi_OrderCode"
              [(ngModel)]="kymw4100Model.medium" style="width: 100%;">
            </app-plan-medium-type-combo-box>
          </div>

          <label class="list-input-title">ページ</label>
          <div class="list-input-content">
            <input type="text" class="page" id="txt_StartPageNum" #txt_StartPageNum plessInputTextSub
              [restrict]="'[0-9]'" [maxlength]="3" forcedEnabledMode="true" [tabindex]="0"
              [(ngModel)]="kymw4100Model.startPageNum" [width]="'3rem'"/>
            <label>～</label>
            <input type="text" class="page" id="txt_EndPageNum" [(ngModel)]="kymw4100Model.endPageNum"
              #txt_EndPageNum plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" forcedEnabledMode="true"
              [tabindex]="0" [width]="'3rem'"/>
          </div>

          <label class="list-input-title">会員生協</label>
          <div class="list-input-content">
            <app-checkbox-label label="全" id="chk_AllCoop" #chk_AllCoop [subid]="'chk_AllCoop'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.allCoop"
              (change)="eventAllCoop_CHANGEHandler()">
            </app-checkbox-label>
            <app-checkbox-label label="い" id="chk_Ibaraki" #chk_Ibaraki [subid]="'chk_Ibaraki'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.ibaraki">
            </app-checkbox-label>
            <app-checkbox-label label="と" id="chk_Tochigi" #chk_Tochigi [subid]="'chk_Tochigi'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.tochigi">
            </app-checkbox-label>
            <app-checkbox-label label="ぐ" id="chk_Gunma" #chk_Gunma [subid]="'chk_Gunma'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.gunma">
            </app-checkbox-label>
            <app-checkbox-label label="ち" id="chk_Chiba" #chk_Chiba [subid]="'chk_Chiba'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.chiba">
            </app-checkbox-label>
            <app-checkbox-label label="さ" id="chk_Saitama" #chk_Saitama [subid]="'chk_Saitama'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.saitama">
            </app-checkbox-label>
            <app-checkbox-label label="とう" id="chk_Tokyo" #chk_Tokyo [subid]="'chk_Tokyo'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.tokyo">
            </app-checkbox-label>
            <app-checkbox-label label="な" id="chk_Nagano" #chk_Nagano [subid]="'chk_Nagano'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.nagano">
            </app-checkbox-label>
            <app-checkbox-label label="に" id="chk_Niigata" #chk_Niigata [subid]="'chk_Niigata'" layout="relative"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw4100Model.niigata">
            </app-checkbox-label>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Output" class="btn-primary" forcedEnabledMode="true" [tabindex]="0"
            (click)="eventOutput_CLICKHandler()">出力</button>
        </div>
        <!--終了ボタン追加のためコメントアウト-->
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>